export default __webpack_public_path__ + "static/11-87734c78b22dd02c71e929704f1728f5.png";